import FormField from '@cloudscape-design/components/form-field';
import CSDTextarea from '@cloudscape-design/components/textarea';
import { Controller, useFormContext } from 'react-hook-form';

type TextareaProps = {
  name: string;
  label?: string;
  description?: string;
  defaultValue?: string;
  placeholder?: string;
  disabled?: boolean;
  stretch?: boolean;
  rows?: number;
};

const Textarea = ({
  name,
  label,
  description,
  defaultValue = undefined,
  placeholder = '',
  disabled = false,
  stretch = false,
  rows = undefined,
}: TextareaProps) => {
  const { control, formState } = useFormContext();
  return (
    <FormField
      stretch={stretch}
      description={description}
      label={label}
      errorText={formState.errors[name]?.message as string | undefined}
    >
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <CSDTextarea
            {...field}
            rows={rows}
            onChange={({ detail }) => field.onChange(detail.value)}
            placeholder={placeholder}
            disabled={disabled}
          />
        )}
      />
    </FormField>
  );
};

export default Textarea;
